import * as React from 'react';
import HeaderPage from '../../components/commons/HeaderPage';
import ConsultaForm from '../../components/crm/consulta/ConsultaForm';

export default class Crm_Consulta extends React.Component {
    render() {
        return <div className='page'>
            <HeaderPage
                path=' CRM'
                name='Consulta' />
            <ConsultaForm />
        </div>;
    }
}